import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const stockValuationMethod = v.union(
  v.literal("fifo"),
  v.literal("lifo"),
  v.literal("average_cost"),
);

export const stockConfigurationValidator = v.object({
  branchId: v.id("branches"),

  deductOnInvoiceComplete: v.boolean(),
  deductOnSaleComplete: v.boolean(),
  allowNegativeStock: v.boolean(),
  // Venta en 'pending' reserva stock; se libera al completar o cancelar.
  reserveOnSale: v.optional(v.boolean()),
  // Factura en 'pending' (borrador) reserva stock; se libera al procesar, cancelar o eliminar.
  reserveOnInvoicePending: v.optional(v.boolean()),

  trackExpiration: v.boolean(),
  alertDaysBeforeExpiry: v.optional(v.number()),

  valuationMethod: stockValuationMethod,

  defaultMovementReason: v.optional(v.string()),

  // Cupo GLOBAL (no por producto) que un vendedor puede consumir emitiendo facturas offline.
  offlineStockReservations: v.optional(
    v.array(
      v.object({
        userId: v.id("users"),
        reservedQty: v.number(),
        lowStockThreshold: v.optional(v.number()),
      }),
    ),
  ),

  internalControl,
});

export const stock_configurations = defineTable(stockConfigurationValidator)
  .index("by_branch_id", ["branchId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_created_at", ["internalControl.createdAt"]);
